export default "__VITE_ASSET__BOfPqOim__"